import { render, staticRenderFns } from "./matching-card.vue?vue&type=template&id=217102d8&scoped=true&"
import script from "./matching-card.vue?vue&type=script&lang=ts&"
export * from "./matching-card.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card.vue?vue&type=style&index=0&id=217102d8&lang=scss&scoped=true&"
import style1 from "./matching-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217102d8",
  null
  
)

export default component.exports